var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownloadIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ic-download-file",
    xmlns: "http://www.w3.org/2000/svg",
    width: 9.059,
    height: 8,
    viewBox: "0 0 9.059 8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_4778",
    "data-name": "Path 4778",
    d: "M8.264,7.284a.283.283,0,0,1-.2-.088L6.078,5.121a.283.283,0,0,1,.2-.479H7.321V2.472A.472.472,0,0,1,7.792,2h.944a.472.472,0,0,1,.472.472v2.17h1.038a.283.283,0,0,1,.2.479L8.469,7.2A.283.283,0,0,1,8.264,7.284Z",
    transform: "translate(-3.735 -2)",
    fill: "#146f62"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4779",
    "data-name": "Path 4779",
    d: "M8.4,19.51H.661A.661.661,0,0,1,0,18.849v-.189A.661.661,0,0,1,.661,18H8.4a.661.661,0,0,1,.661.661v.189A.661.661,0,0,1,8.4,19.51Z",
    transform: "translate(0 -11.961)",
    fill: "#146f62"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadIcon);
export default __webpack_public_path__ + "static/media/DownloadIcon.9ebc5abbcc9403f68279120fd63daa9f.svg";
export { ForwardRef as ReactComponent };